import { dom } from '../utils/dom';
import { TweenMax, Expo } from 'gsap';
import pubSub from '../utils/pubSub';

const footUp = 155;
class PagesView {
  constructor() {
    this.init();
  }

  init() {
    this.pages = [
      dom.els.page0,
      dom.els.page1,
      dom.els.page2,
      dom.els.page3,
      dom.els.page4
    ];
    this.inners = [];
    this.pages.forEach((page, i) => {
      page.style.visibility = 'hidden';
      this.inners[i] = page.querySelector('.page-inner');
    });

    window.addEventListener('resize', e => this.onResize(e));
    this.onResize();

    this.currPage = 0;
    this.x = 0;
    this.dx = 0;

    this.loop = this.loop.bind(this);
    this.next = this.next.bind(this);
    this.prev = this.prev.bind(this);
    this.fadeFirst = this.fadeFirst.bind(this);
    this.fadeNext = this.fadeNext.bind(this);
    this.resetToFirst = this.resetToFirst.bind(this);
    this.showMenu = this.showMenu.bind(this);
    this.hideMenu = this.hideMenu.bind(this);
    // this.stateChanged = this.stateChanged.bind(this);

    this.loop();
    this.initBtns();
    this.introAnimation();

    dom.els.ham.addEventListener(dom.clickOrTouchEnd(), this.showMenu);
    dom.els.closeMenu.addEventListener(dom.clickOrTouchEnd(), this.hideMenu);
    dom.els.basicAd.addEventListener(dom.clickOrTouchEnd(), e => {
      TweenMax.to(dom.els.basicAd, 0.2, {
        opacity: 0,
        onComplete: () => {
          //this.next();
          dom.els.basicAd.style.display = 'none';
        }
      });
    });

    [...document.querySelectorAll('.sub-logo svg')].forEach(el => {
      el.addEventListener(dom.clickOrTouchEnd(), () => {
        if (this.currPage > 0) {
          this.goHome();
          this.hideMenu();
          this.calcHeight();
        } else {
          this.closeSubPage.bind(this)();
        }
      });
    });

    [...document.querySelectorAll('.nav-link')].forEach(a => {
      a.addEventListener('click', e => {
        e.preventDefault();
        let hash = e.target.getAttribute('href');
        if (hash === '#home') {
          if (this.currPage > 0) {
            this.goHome();

            if (window.gtag) {
              window.gtag('config', 'UA-160260985-1', {
                page_title: 'homepage',
                page_path: '/home'
              });
            }
          }
          this.hideMenu();
          this.calcHeight();
        } else if (hash === '#about') {
          this.showAbout();
          this.calcHeight();

          if (window.gtag) {
            window.gtag('config', 'UA-160260985-1', {
              page_title: 'about',
              page_path: '/about'
            });
          }
        } else if (hash === '#faq') {
          this.showFaq();
          this.calcHeight();

          if (window.gtag) {
            window.gtag('config', 'UA-160260985-1', {
              page_title: 'faq',
              page_path: '/faq'
            });
          }
        } else if (hash === '#contact') {
          this.showContact();
          this.calcHeight();

          if (window.gtag) {
            window.gtag('config', 'UA-160260985-1', {
              page_title: 'contact',
              page_path: '/contact'
            });
          }
        }
      });
    });

    var lastHash;
    var hashChange = e => {
      if (e) {
        e.preventDefault();
      }
      console.log('changed', location.hash, this.currPage);
      if (window.location.hash == '') {
        console.log('GO HOME');
        this.goHome();
      } else if (window.location.hash == '#about-you' && this.currPage != 1) {
        if (lastHash == '#about-work') {
          //this.currPage--;
          this.prev();
          //this.fadeNext();
        } else {
          this.currPage = 0;
          this.fadeNext();
        }
      } else if (window.location.hash == '#about-work' && this.currPage != 2) {
        if (lastHash == '#about-you') {
          this.currPage = 1;
          this.next();
        } else {
          this.prev();
        }
      } else if (window.location.hash == '#your-plan' && this.currPage != 3) {
        if (lastHash == '#about-work') {
          this.currPage = 2;
          this.next();
        } else {
          this.prev();
        }
      } else if (
        window.location.hash == '#your-results' &&
        this.currPage != 4
      ) {
        if (lastHash == '#your-plan') {
          this.currPage = 3;
          this.next();
        } else {
          this.prev();
        }
      }
      lastHash = window.location.hash;
    };

    history.replaceState(null, null, ' ');
    //if (window.location.hash != '') window.location.hash = '';

    window.addEventListener('hashchange', hashChange);
    //hashChange();

    dom.els.closeSubPage.addEventListener(
      dom.clickOrTouchEnd(),
      this.closeSubPage.bind(this)
    );

    this.calcHeight();

    pubSub.on('form:adjustHeight', this.calcHeight.bind(this));

    window.PP = this;
  }

  hideMenu() {
    TweenMax.to(dom.els.menu, 0.3, {
      opacity: 0,
      onComplete: () => {
        dom.els.menu.style.display = 'none';
      }
    });
  }

  showMenu() {
    dom.els.menu.style.opacity = 1;
    TweenMax.from(dom.els.menu, 0.3, {
      x: 30,
      opacity: 0
    });

    dom.els.menu.style.display = 'block';
  }

  closeSubPage() {
    dom.els.headerNav.style.display = 'block';
    dom.els.pages.style.display = 'block';
    dom.els.subPages.style.display = 'none';

    dom.els.contact.style.display = 'none';
    dom.els.about.style.display = 'none';
    dom.els.faq.style.display = 'none';
  }

  showAbout() {
    this.hideMenu();
    dom.els.headerNav.style.display = 'none';
    dom.els.pages.style.display = 'none';
    dom.els.subPages.style.display = 'block';

    dom.els.contact.style.display = 'none';
    dom.els.faq.style.display = 'none';
    dom.els.about.style.display = 'block';
  }

  showFaq() {
    this.hideMenu();
    dom.els.headerNav.style.display = 'none';
    dom.els.pages.style.display = 'none';
    dom.els.subPages.style.display = 'block';

    dom.els.contact.style.display = 'none';
    dom.els.about.style.display = 'none';
    dom.els.faq.style.display = 'block';
  }

  showContact() {
    this.hideMenu();
    dom.els.headerNav.style.display = 'none';
    dom.els.pages.style.display = 'none';
    dom.els.subPages.style.display = 'block';

    dom.els.about.style.display = 'none';
    dom.els.faq.style.display = 'none';
    dom.els.contact.style.display = 'block';
  }

  goHome() {
    window.location.hash = '';
    this.pages.forEach((page, i) => {
      page.style.visibility = 'hidden';
    });
    dom.els.headerNav.style.display = 'block';
    dom.els.pages.style.display = 'block';
    dom.els.subPages.style.display = 'none';

    dom.els.contact.style.display = 'none';
    dom.els.about.style.display = 'none';
    dom.els.faq.style.display = 'none';

    if (this.currPage !== 0) {
      this.resetToFirst();
    }
  }

  windowScrollTop() {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  }

  introAnimation() {
    dom.els.page0.style.visibility = 'visible';

    if (
      /MSIE (\d+\.\d+);/.test(navigator.userAgent) ||
      navigator.userAgent.indexOf('Trident/') > -1
    ) {
      return;
    }

    // const logoScale = window.isMobile ? 1.1 : 1.2;
    TweenMax.from(dom.els.logo, 0.3, {
      opacity: 0,
      scaleX: 1.2,
      scaleY: 1.2
    });

    TweenMax.from(dom.els.subTitle, 0.3, {
      opacity: 0,
      scaleX: 1.2,
      scaleY: 1.2,
      delay: 0.2
    });

    TweenMax.from(dom.els.bulletOne, 0.3, {
      opacity: 0,
      scaleX: 1.2,
      scaleY: 1.2,
      delay: 0.4
    });

    TweenMax.from(dom.els.bulletTwo, 0.3, {
      opacity: 0,
      scaleX: 1.2,
      scaleY: 1.2,
      delay: 0.6
    });
    TweenMax.from(dom.els.bulletThree, 0.3, {
      opacity: 0,
      scaleX: 1.2,
      scaleY: 1.2,
      delay: 0.8
    });

    TweenMax.from(dom.els.introNextBtn, 0.3, {
      opacity: 0,
      scaleX: 1.2,
      scaleY: 1.2,
      delay: 1.0
    });

    // `onResize` call?
  }

  initBtns() {
    const {
      introNextBtn,
      costNextBtn,
      anotherNextBtn,
      nextResultsBtn,
      makeNewOne
    } = dom.els;

    introNextBtn.addEventListener(dom.clickOrTouchEnd(), this.fadeNext);
    costNextBtn.addEventListener(dom.clickOrTouchEnd(), e => {
      if (window.location.hash != '#debug') {
        window.location.hash = '#about-work';
      }
      this.next(e);
    });
    anotherNextBtn.addEventListener(dom.clickOrTouchEnd(), e => {
      if (window.location.hash != '#debug') {
        window.location.hash = '#your-plan';
      }
      this.next(e);
    });
    nextResultsBtn.addEventListener(dom.clickOrTouchEnd(), () => {
      if (this.forms.evalBenefitforms()) {
        if (window.location.hash != '#debug') {
          window.location.hash = '#your-results';
        }
        pubSub.trigger('forms:performCalc');
        this.next();
      } else {
        this.forms.badForm.scrollIntoView();
        // alert('Please check the information you entered for you benefits.');
      }
    });
    makeNewOne.addEventListener(dom.clickOrTouchEnd(), () => {
      // window.location.reload();
      this.goHome();
    });
    // costPrevBtn.addEventListener(dom.clickOrTouchEnd(), this.fadeFirst);
    // marginPrevBtn.addEventListener(dom.clickOrTouchEnd(), this.prev);
  }

  potentialReset() {
    // reset location menu
    // reset start date
  }

  onScroll() {
    // const { sticky, expand } = dom.els;
    // const top = sticky.getBoundingClientRect().top;
    //
    // if (top < window.innerHeight / 2) {
    //   if (!expand.classList.contains('inviz')) {
    //     expand.classList.add('inviz');
    //   }
    // } else if (expand.classList.contains('inviz')) {
    //   expand.classList.remove('inviz');
    // }
  }

  onExpand() {
    // dom.els.footer.style.top = '';
    // document.querySelector('.mob-sticky-hide').scrollIntoView();
    // dom.els.sticky.scrollIntoView();
  }

  loop() {
    this.x += (this.dx - this.x) / 4;

    // @TODO right here joe
    dom.style(dom.els.pages, {
      transform: `translateX(${this.x}px)`
    });
    window.requestAnimationFrame(this.loop);
  }

  fadeNext() {
    // console.log(this.currPage, 'page');
    dom.els.page1.style.visibility = 'visible';
    TweenMax.to(dom.els.headerBg, 0.6, {
      opacity: 1
    });
    TweenMax.to(dom.els.navLoc, 0.6, {
      opacity: 1
    });

    TweenMax.to(dom.els.page0, 0.25, {
      opacity: 0,
      onComplete: () => {
        this.next();
        this.x = this.dx;
        TweenMax.from(dom.els.page1, 0.25, { opacity: 0 });
        setTimeout(() => {
          TweenMax.set(dom.els.page0, { opacity: 1 });

          if (window.location.hash != '#debug') {
            window.location.hash = '#about-you';
          }

          if (localStorage.agree == null || window.location.hash == '#debug') {
            localStorage.agree = 'yes';
            TweenMax.from(dom.els.agreePop, 0.25, {
              opacity: 0,
              scale: 1.5,
              delay: 0.0
            });
            dom.els.agreePop.style.display = 'block';
            dom.els.checky.addEventListener(dom.clickOrTouchEnd(), () => {
              TweenMax.to(dom.els.agreePop, 0.25, {
                opacity: 0,
                delay: 0.5,
                onComplete: () => {
                  dom.els.agreePop.style.pointerEvents = 'none';
                  dom.els.agreePop.style.display = 'none';
                }
              });
            });
          }
        }, 300);
      }
    });
  }

  fadeFirst() {
    TweenMax.to(dom.els.page1, 0.25, {
      opacity: 0,
      onComplete: () => {
        this.prev();
        this.x = this.dx;
        TweenMax.from(dom.els.page0, 0.25, { opacity: 0 });
        setTimeout(() => {
          TweenMax.set(dom.els.page1, { opacity: 1 });
        }, 300);
      }
    });
  }

  resetToFirst() {
    this.currPage = 0;
    dom.els.page0.style.visibility = 'visible';
    TweenMax.to(dom.els.headerBg, 0.6, {
      opacity: 0
    });
    TweenMax.to(dom.els.navLoc, 0.6, {
      opacity: 0
    });

    TweenMax.to(dom.els.page2, 0.25, {
      opacity: 0,
      onComplete: () => {
        pubSub.trigger('resetModel');
        this.currPage = 0;
        this.pageChanged();
        this.dx = 0;
        this.x = this.dx;
        TweenMax.from(dom.els.page0, 0.25, { opacity: 0 });
        setTimeout(() => {
          this.windowScrollTop();

          TweenMax.set(dom.els.page2, { opacity: 1 });
        }, 300);
      }
    });
  }

  pageChanged() {
    console.log(this.currPage);
    if (this.currPage > 0) {
      setTimeout(() => {
        this.pages[this.currPage - 1].style.visibility = 'hidden';
      }, 1000);
      this.pages[this.currPage].style.visibility = 'visible';
    }
    if (this.currPage == 1) {
      pubSub.trigger('firstSlider:hintAnimation');
      dom.els.aboutYouDot.classList.add('loc-dot-selected');

      if (window.gtag) {
        window.gtag('config', 'UA-160260985-1', {
          page_title: 'about-you',
          page_path: '/about-you'
        });
      }
      // dom.els.aboutWorkDot.classList.add('loc-dot-selected');
    }
    if (this.currPage == 2) {
      if (window.gtag) {
        window.gtag('config', 'UA-160260985-1', {
          page_title: 'about-work',
          page_path: '/about-work'
        });
      }
    }

    if (this.currPage == 3) {
      if (window.gtag) {
        window.gtag('config', 'UA-160260985-1', {
          page_title: 'benefits',
          page_path: '/benefits'
        });
      }
    }

    if (this.currPage == 2 || this.currPage == 3) {
      dom.els.aboutYouDot.classList.remove('loc-dot-selected');
      dom.els.aboutWorkDot.classList.add('loc-dot-selected');
    } else {
      // document.body.style.height = '100%';
      dom.els.aboutWorkDot.classList.remove('loc-dot-selected');
    }

    document.body.classList.remove('showing-results');
    if (this.currPage == 4) {
      if (window.gtag) {
        window.gtag('config', 'UA-160260985-1', {
          page_title: 'your-plan',
          page_path: '/your-plan'
        });
      }

      document.body.classList.add('showing-results');
    }
    if (this.pages[this.currPage].dataset.white) {
      setTimeout(() => {
        // document.body.style.background = 'white';
      }, 300);
    } else {
      document.body.style.background = null;
    }
    this.calcHeight();
    this.windowScrollTop();
  }

  showAd() {
    dom.els.basicAd.style.opacity = 0;
    dom.els.basicAd.style.display = 'block';
    TweenMax.to(dom.els.basicAd, 0.2, { opacity: 1 });
  }

  next() {
    if (window.location.hash != '#debug' && this.currPage > 0) {
      if (Math.random() < 0.5) {
        if (window.location.hash === '#ads') {
          this.showAd();
        }
      }
    }
    this.currPage++;
    this.dx -= dom.innerWidth();
    this.pageChanged();
  }

  prev() {
    this.currPage--;
    this.dx += dom.innerWidth();
    this.pageChanged();
  }

  calcHeight() {
    var isDesktop = !isMobile.any && window.innerWidth > 600;
    var paddy = isDesktop ? 70 * 2 : 70 * 2;

    if (dom.els.subPages.style.display == 'block') {
      let h =
        Math.max(dom.els.subPages.clientHeight, window.innerHeight) + paddy;
      dom.els.mainContent.style.height = h + 'px';
      dom.els.pages.style.height = h + 'px';
      return;
    }
    // @TODO about or FAQ shown!
    // @TODO event to trigger resize
    let inner = this.inners[this.currPage];

    if (inner) {
      let h = Math.max(inner.clientHeight, window.innerHeight) + paddy;
      dom.els.mainContent.style.height = h + 'px';
      dom.els.pages.style.height = h + 'px';
    } else {
    }
  }
  doTheResize() {
    let innerWidth = dom.innerWidth();
    this.x = this.dx = -(this.currPage * innerWidth);
    const isDesktop = false; // !isMobile.any && window.innerWidth > 600;
    // dom.els.pages.style.height =
    this.calcHeight();
    this.pages.forEach(function(page, i) {
      const x = innerWidth * i;
      dom.style(page, {
        top: isDesktop ? '50%' : '',
        transform: `translateX(${x}px) ${isDesktop ? 'translateY(-50%)' : ''}`
      });
    });
  }
  onResize() {
    clearTimeout(this.idA);
    clearTimeout(this.idB);
    this.doTheResize();
    this.idA = setTimeout(() => this.doTheResize(), 500);
    this.idB = setTimeout(() => this.doTheResize(), 1000);
  }
}

export default PagesView;
